import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded px-3 text-center border border-gray-300 h-8 hover:bg-gray-100" }


export default /*#__PURE__*/_defineComponent({
  props: {
  text: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

// eslint-disable-next-line @typescript-eslint/no-unused-vars


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _toDisplayString(__props.text), 1))
}
}

})